import _ from 'lodash'
import { useContext, useMemo } from 'react'
import { SwiperSlide } from 'swiper/react'

import { PageAreaContext } from 'global/cnr/contexts/PageAreaContext'
import { gEnums } from 'global/enums/globalEnums'

import { uniqueKey } from 'global/common/keys'
import PageItem from 'global/page/PageItem'
import { Swiper_Any } from './Swiper_Any'
import { _swiperMenuTypes } from './SwiperMenu'
import { sortObj } from 'global/common/sorting'
import { ParentContext } from 'global/cnr/contexts/ParentContext'

export const Swiper_PageArea = ({
  swipeContentType,
  swiperMenuType = _swiperMenuTypes.menu,
  isChild = false,
  applyFade = false,
}) => {


  const parentContext = useContext(ParentContext);
  const { states, fns } = parentContext ?? {};
  const { paps_state, page_state } = states ?? {};
  const { viewPathKey } = paps_state ?? {};
  const { aps_page } = _.get(page_state, 'pageSettings', {});
  const { layout } = aps_page ?? {}
  const { layoutType } = layout ?? {}

  const pageAreaContext = useContext(PageAreaContext)
  const { pageArea_state } = pageAreaContext ?? {}
  const { pageItemsShown, pageData } = pageArea_state ?? {}

  const { slides, menuItems } = useMemo(() => {
    if (swipeContentType !== gEnums.swipeContentTypes.pageAreaContent || _.isEmpty(pageItemsShown)) return []

    let _pageItemShow = pageItemsShown

    if (!_.isEmpty(pageData) && pageItemsShown && layoutType === gEnums.layoutTypes.swipeableHidden) {
      _pageItemShow = _.omitBy(_pageItemShow, (val, key) => {
        return pageData?.[key]?.count === 0
      })
    }

    const sorted = _.sortBy(_pageItemShow, 'position')

    const _slides = _.map(sorted, (csi, csiKey, idx) => (
      <SwiperSlide
        key={uniqueKey('sipi', csi.key)}
        className={`sst-${csi.key}`}>
        <PageItem
          uivi={csi.key}
          tabIndex={idx}
          returnCount={true}
          from="aaa"
          inSwiper={true}
          isMounted={true} // or lazy logic here
        />
      </SwiperSlide>
    ))
    return { slides: _slides, menuItems: sorted }
  }, [pageItemsShown, pageData, swipeContentType])

  return (
    <Swiper_Any
      swKey={viewPathKey}
      menuItems={menuItems}
      swipeContentType={swipeContentType}
      swiperMenuType={swiperMenuType}
      isChild={false}
      applyFade={applyFade}
      slides={slides}
      showButtons={true}
    />

  )
}